import { HttpClient, parseJSONApiResponse } from '@opallabs/api'
import loadDownloads from '../loadDownloads'
import { loadJsonApiEntities } from '../loadJsonApiEntities'
import setLoader from '../setLoader'

const fetchNotifications = ({ pageSize, page, parent }) =>
  HttpClient().get(
    '/api/v1/notifications?include=referenced_objects,checkpoint',
    {
      params: {
        'page[limit]': pageSize,
        'page[offset]': page,
        'filter[type]': parent.slice(0, -1),
      },
    }
  )

const getNotifications = (params) => (dispatch) => {
  dispatch(setLoader({ [params.parent]: true }))
  return fetchNotifications(params)
    .then((response) => {
      const payload = {
        items: parseJSONApiResponse(response.data),
        meta: response.data.meta,
      }
      if (params.parent === 'notifications') {
        dispatch(loadJsonApiEntities(response.data))
      } else {
        dispatch(loadDownloads(payload))
      }
      return dispatch(setLoader({ [params.parent]: false }))
    })
    .catch((err) => {
      console.log(err)
      throw err
    })
}

export default getNotifications
